import { PERMISSION } from '@/constants/permission.constant';

const conditionList = () => import('@/views/configuration/conditions/List.vue');
const conditionAdd = () => import('@/views/configuration/conditions/Add.vue');
const conditionEdit = () => import('@/views/configuration/conditions/Edit.vue');

export const conditionRoute = [
  {
    path: '/configuration/conditions',
    name: 'condition',
    component: conditionList,
    meta: { requiresAuth: false, permissions: [PERMISSION.CONDITION_READ] },
  },

  {
    path: '/configuration/conditions/create',
    name: 'condition-create',
    component: conditionAdd,
    meta: { requiresAuth: false, permissions: [PERMISSION.CONDITION_CREATE] },
  },
  {
    path: '/configuration/conditions/:id/edit',
    name: 'condition-edit',
    component: conditionEdit,
    meta: { requiresAuth: false, permissions: [PERMISSION.CONDITION_UPDATE] },
  },
];
